/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    'use strict';

    interface IDatePickerScope extends ng.IScope {
        minDate: Date;
        maxDate: Date;
        dateFilter: Function;
        ngModel: Date;
        ngChange: Function;
        ngFocus: Function;
        contentKey: string;
        disabled: boolean;
        required: boolean;
        tabIndex: string;
        hideDateLabel?: boolean;
        fieldName?: string;
        viewType?: 'startMonth' | 'endMonth';
        yearView?: string;
        inputIsReadOnly?: boolean;

        selectMonth: Function;
        changeLocal: Function;
        focus: Function;
        initDatepicker: Function;

        isOpen: boolean;
        firstInitialization: boolean;
        fromReport: boolean;
    }

    export class MeevoDatePicker implements angular.IDirective {
        restrict = 'E';
        require = 'ngModel';
        scope = {
            minDate: '=',
            maxDate: '=',
            dateFilter: "=?",
            ngModel: '=ngModel',
            ngChange: '&ngChange',
            ngFocus: '&ngFocus',
            contentKey: '@?',
            disabled: '=?ngDisabled',
            required: '=?ngRequired',
            tabIndex: '@tabIndex',
            hideDateLabel: '=?',
            fieldName: '@?',
            viewType: '@?',
            yearView: '=?',
            fromReport: '=?',
            inputIsReadOnly: '=?',
            skipFirstInitialization: '=?'
       };

        template = `<div class="date-picker-wrapper" ng-class="{'meevo-button-no-cursor' : disabled}"><div class="meevo_input_wrapper" ng-if="required || contentKey"><label translate="{{contentKey}}"></label>
            <div ng-class="{'ng-dirty required_red_bubble' : required && !ngModel}"></div></div>
            <div class="red_border_invalid_date dateValid " style="width: 100%; padding-right:0;">
                  <md-datepicker 
                    tabindex="{{tabIndex}}" 
                    id="{{ contentKey + $parent.$index }}"
                    md-current-view="{{yearView ? 'year' : 'month'}}" 
                    md-is-open="isOpen" 
                    ng-model="ngModel" 
                    ng-click="viewType ? initDatepicker() : null" 
                    ng-change="changeLocal()"
                    md-min-date="minDate" 
                    md-max-date="maxDate"
                    md-date-filter="dateFilter"
                    ng-disabled="disabled" 
                    ng-required="required" 
                    ng-focus="focus()"                    
                    name="{{fieldName}}"
                    ng-class="{'meevo-button-no-pointer' : disabled}"
                ></md-datepicker>
            </div>
            <div ng-hide="hideDateLabel" class="date-fake-btn"><div class="date-label-day"> {{ngModel | date:'EEE' }} </div></div></div>`;

        link(scope: IDatePickerScope, element, attrs, ngModel: ng.INgModelController) {
            const startEndMonth = ['startMonth', 'endMonth'].indexOf(scope.viewType) !== -1;
            let $timeout = this.$timeout;
            let $input = $(element).find('md-datepicker input');      /*  Support Culture Setting  */
            let format = startEndMonth ? 'MM/YYYY' : moment.localeData().longDateFormat('L');

            scope.isOpen = false;
            scope.firstInitialization = !scope.skipFirstInitialization;
            // parent scope isn't being updated prior to ngChange being directly called so the
            //$timeout call forces the callback to be executed on the next digest cycle so after the parent scope has been updated with the new model value
            scope.changeLocal = function () {
                if (scope.ngChange) {
                    $timeout(function () {
                        scope.ngChange();
                    });
                }
            };
            scope.focus = function () {
                if (angular.isFunction(scope.ngFocus)) {
                    scope.ngFocus();
                }
            };

            $(element).focusout((event) => {
                let selectedDate = moment($(event.target).val(), format, true);
                if (selectedDate.isValid()) {
                    ngModel.$setViewValue(selectedDate.toDate());
                }
            });

            $(element).find('.md-datepicker-input').attr('tabindex', scope.tabIndex);

            scope.initDatepicker = () => {
                setTimeout(() => {
                    scope.selectMonth();
                    $('tbody').bind('DOMSubtreeModified', () => {
                        scope.selectMonth();
                    });
                });
            };

            scope.selectMonth = () => {
                let results = $('.md-calendar-date:not(.md-calendar-date-disabled)');

                [].forEach.call(results, item => {
                    item.addEventListener('click', item => {
                        let timestamp = parseInt(item.currentTarget.attributes.getNamedItem('data-timestamp').nodeValue);
                        let date = moment(timestamp).endOf('month').toDate();

                        switch(scope.viewType) {
                            case 'startMonth':
                                date =  moment(timestamp).toDate();
                                break;
                            case 'endMonth':
                                date = moment(timestamp).endOf('month').toDate();

                        }

                        ngModel.$setViewValue(date);
                        scope.isOpen = false;
                    });
                });
            };

            scope.$watch('maxDate', (newValue) => {
                if (newValue && scope.ngModel && scope.ngModel > newValue) {
                    ngModel.$setViewValue(newValue);
                } else if (scope.firstInitialization && newValue && !scope.ngModel) {
                    if(moment(moment(newValue).format(format)).isValid()){
                        ngModel.$setViewValue(newValue);
                    } else if(scope.yearView && startEndMonth){
                        $input.val(moment(newValue).format(format));
                    }
                    ngModel.$setViewValue(newValue);
                    scope.firstInitialization = false;
                }
            });

            scope.$watch('ngModel', (newValue) => {
                if (angular.isDefined(newValue)) {
                    let selectedDateFormatted = moment(newValue).format(format);
                    let selectedDate = moment(new Date(selectedDateFormatted));

                    if (selectedDate.isValid()) {
                        $input.val(selectedDateFormatted);
                    }else if(scope.yearView && startEndMonth){
                        $input.val(moment(newValue).format(format));
                    }
                }
                else {
                    // it appears that the md-datepicker set the input to the current date if the model is undefined
                    // so setting it to blank here clears it out.   Setting the model to null if its undefined
                    // seems to clear the input out as well, but this just seemed easier.
                    $input.val("");
                }
            });

            if (!ngModel.$modelValue && scope.fromReport) {
                ngModel.$setViewValue(new Date());
                
                if(scope.viewType === 'endMonth') {
                    ngModel.$setViewValue(
                        moment(scope.maxDate).endOf('month').toDate()
                    );
                }

                if (scope.viewType === 'startMonth') {
                    ngModel.$setViewValue(
                        moment(scope.maxDate).startOf('month').toDate()
                    );
                }

                if (scope.maxDate && moment().startOf('day').isAfter(scope.maxDate, 'day')) {
                    ngModel.$setViewValue(
                        moment(scope.maxDate).toDate()
                    );
                }
            }

            $timeout(() => {
                $input.prop('disabled', (startEndMonth && !scope.inputIsReadOnly) ? true : scope.disabled);


                if (scope.inputIsReadOnly) {
                    $input.prop('readonly', true);
                    $input.bind('click', () => element.find('button')[0].click());
                }
            });
        };

        constructor(private $timeout) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => {
                return new MeevoDatePicker($timeout);
            };
            directive.$inject = ['$timeout'];
            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoDatePicker', MeevoDatePicker.factory());
}
